import { useSettings } from "./useSettings";

/**
 * useFeatureGate — Vérifie qu'un module DigiPilote est activé.
 *
 * Usage :
 *   const enabled = useFeatureGate("sport_communication_enabled");
 *   if (!enabled) return null;
 *
 * Ou avec dépendance :
 *   const canShowPronos = useFeatureGate("sport_match_pronos_enabled", "sport_supporters_enabled");
 *
 * Retourne `false` tant que les settings ne sont pas chargés (évite le flicker).
 * Retourne `true` si le flag n'existe pas (rétro-compat — module activé par défaut
 * si non explicitement listé).
 */
export function useFeatureGate(key, ...dependencies) {
  const { settings } = useSettings();
  if (!settings) return false; // chargement → fail-closed
  if (settings[key] === false) return false;
  for (const dep of dependencies) {
    if (settings[dep] === false) return false;
  }
  return true;
}

/**
 * Variant qui retourne aussi l'état de chargement, utile pour afficher un skeleton.
 */
export function useFeatureGateWithLoading(key, ...dependencies) {
  const { settings } = useSettings();
  const loading = !settings;
  if (loading) return { enabled: false, loading: true };
  const enabled = settings[key] !== false && dependencies.every((d) => settings[d] !== false);
  return { enabled, loading: false };
}
